import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { FormValidationsService, QuoteDataCaptureService, ProductCodeValidators, UtilService } from '../../../../shared';
import * as moment from 'moment';

@Component({
  selector: 'app-cashout-retirement-plan',
  templateUrl: './cashout-retirement-plan.component.html',
  styleUrls: ['./cashout-retirement-plan.component.scss']
})
export class CashoutRetirementPlanComponent implements OnInit, OnChanges {

  constructor(private utilService: UtilService) { }
  @Input() quoteForm: UntypedFormGroup;
  @Input() userInputDetail;
  @Input() sliderErrorVisible;
  @Input() showTaxfreeSlider;
  @Input() showIncomeSlider;
  @Input() showTaxfreeInput;
  @Input() taxfreePerc;
  @Input() pensionArray;
  @Input() taxFreeFund;
  @Input() source;
  // @Output() scrollEndHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() calculatedValueClickHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() valueChangeIncomeSlider:EventEmitter<any> = new EventEmitter<any>()
  @Output() currencyChangeEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  disableSlider: boolean = false;
  @Output() dateValueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() dateInputHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() contentData: any;
  @Output() corpTooltipHandler: EventEmitter<any> = new EventEmitter<any>();
  @Input() isDateInputRequired = false;
  currentDateFlag = false;
  currentAndStartDateError: boolean = false;
  startDateBeforeFormChanged: string;
  @Input() loginFlag;
  ngOnInit() {
  }
  ngOnChanges(val) {
    if (val && val.quoteForm && val.quoteForm.currentValue
      && (val.quoteForm.currentValue !== val.quoteForm.previousValue)) {
      let questionOptions = this.userInputDetail.radioButtonCORPFrequencyConfig.questionOptions;
      questionOptions.forEach((val) => {
        val.disable = true;
      });
      this.loadEditView(val.quoteForm.currentValue.controls, questionOptions);
    }
  }
  changeScrollParams(value) {
    if (value) {
      let questionOptions = this.userInputDetail.radioButtonCORPFrequencyConfig.questionOptions;
      if (value.controlName && value.controlName === 'termyear') {
        if (value.currentValue === 25) {
          this.userInputDetail.sliderMonthlyTermConfig.value = 0;
          this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault = false;
          this.quoteForm.controls['termmonth'].setValue(0);
          this.userInputDetail.radioButtonCORPFrequencyConfig.disabled = false;
          this.resetFrequency(questionOptions, true);
          this.setFrequency({ currentValue: 0 }, questionOptions);
        } else {
          if (this.disableSlider) {
            this.resetFrequency(questionOptions, false);
            questionOptions.forEach((val) => {
              val.disable = false;
            });
          }
          this.disableSlider = false;
        }
      } else if (value.controlName && value.controlName === 'termmonth') {
        this.userInputDetail.radioButtonCORPFrequencyConfig.disabled = false;
        this.resetFrequency(questionOptions, false);
        this.setFrequency(value, questionOptions);
      }
      // this.scrollEndHandler.emit(value);
      value.unselectedByDefault = false;
      if (this.userInputDetail.sliderTermConfig.unselectedByDefault &&
        !this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault) {
        this.sliderErrorVisible = true;
      } else {
        this.sliderErrorVisible = false;
      }
      this.utilService.refreshSlider();
      this.utilService.refreshToggleButton();
    }
  }
  oncalculatedValue = (data, mode?: string) => {
    this.calculatedValueClickHandler.emit(data);
    // this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault = true;
    // this.quoteForm.controls['termmonth'].setValue(0);
    // this.userInputDetail.sliderMonthlyTermConfig.value = 0;
    // this.disableSlider = false;
    // if (data && data.code === 'Y') {
    //   this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault = false;
    //   this.disableSlider = true;
    // } else if (data && data.code === 'M') {
    //   // this.userInputDetail.sliderMonthlyTermConfig.minValue = 0;
    //   this.userInputDetail.sliderMonthlyTermConfig.maxValue = 11;
    //   this.userInputDetail.sliderMonthlyTermConfig.stepsArray = [];
    // } else if (data && data.code === 'Q') {
    //   this.userInputDetail.sliderMonthlyTermConfig.stepsArray = [
    //     { value: 0 },
    //     { value: 3 },
    //     { value: 6 },
    //     { value: 9 },
    //   ];
    // } else if (data && data.code === 'H') {
    //   this.userInputDetail.sliderMonthlyTermConfig.stepsArray = [
    //     { value: 0 },
    //     { value: 6 },
    //   ];
    // }
    // this.utilService.refreshSlider();
  }
  resetFrequency = (questionOptions, sliderFlag) => {
    this.disableSlider = sliderFlag;
    this.quoteForm.controls['frequency'].setValue(null);
    this.quoteForm.controls['frequency'].setValidators([Validators.required]);
    questionOptions.forEach((val) => {
      val.disable = true;
    });
  }
  setFrequency = (value, questionOptions) => {
    switch (value.currentValue) {
      case 0: {
        questionOptions.forEach((val) => {
          val.disable = false;
        });
        break;
      }
      case 3:
      case 9: {
        questionOptions.forEach((val) => {
          if (val.code === 'M' || val.code === 'Q') {
            val.disable = false;
          }
        });
        break;
      }
      case 6: {
        questionOptions.forEach((val) => {
          if (val.code !== 'Y') {
            val.disable = false;
          }
        });
        break;
      }
      default: {
        questionOptions.forEach((val) => {
          if (val.code === 'M') {
            val.disable = false;
          }
        });
        break;
      }
    }
  }
  loadEditView = (value, questionOptions) => {
    if (value) {
      let termYear = value['termyear'].value;
      let termMonth = value['termmonth'].value;
      let monthVal = 0;
      if (termYear === 25) {
        this.disableSlider = true;
      } else {
        this.disableSlider = false;
        monthVal = termMonth;
      }
      this.setFrequency({ currentValue: monthVal }, questionOptions);
    }
  }
  toggleSlider = (data, control) => {
    // switch (control) {
    //   case 'taxfree':
    //     this.showTaxfreeSlider = false;
    //     this.showTaxfreeInput = false;
    //     if (data.code === 'P') {
    //       this.showTaxfreeSlider = true;
    //     } else if (data.code === 'C') {
    //       this.showTaxfreeInput = true;
    //     }
    //     break;
    // }
    this.valueChange.emit(data);
  }

  toggleIncomeSlider = (data, control) => {
    this.valueChangeIncomeSlider.emit(data);
  }
  taxfreeChangeHandler = (val, control) => {
    this.currencyChangeEventEmitter.emit(val);
  }

  // DTC-3649 Start Date Event
  checkDataChange(val) {
    const today = new Date();
    const startDateType = this.quoteForm.controls.currentDate.value;
    // this.currentDateFlag = (this.quoteForm.controls.currentDate.value !== null &&
    //   this.quoteForm.controls.currentDate.value !== '') ? true : false;
    const startDate = this.quoteForm.controls.startDate.value;
    if (this.currentDateFlag && this.startDateBeforeFormChanged !== startDate) {
      if (val[0] === true && val[1] === false) {
        this.currentAndStartDateError = (startDateType === 'A') ? true : false;
      } else {
        this.currentAndStartDateError = false;
        // check condition when both As soon as possible and date field are selected
        this.quoteForm.controls['currentDate'].setValue(null);
        this.quoteForm.controls.currentDate.markAsUntouched();
        this.currentDateFlag = false;
        // de-selects/ refreshes the selected button value
        this.utilService.refreshToggleButton();
      }
    }
  }
  // DTC-3649 "As soon as possible" button Event
  toggleCurrentDate(selectedCode) {
    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1;
    let strDate = dd.toString();
    let strMonth = mm.toString();
    const yyyy = today.getFullYear();
    if (dd < 10) {
      strDate = '0' + dd.toString();
    }
    if (mm < 10) {
      strMonth = '0' + mm.toString();
    }
    const formattedDate = strDate + ' / ' + strMonth + ' / ' + yyyy;
    //this.quoteForm.get('currentDate').setValue(value.code);
    this.quoteForm.get('startDate').setValue(formattedDate);
    this.checkDataChange([false, false]);
    this.currentDateFlag = true;
    this.startDateBeforeFormChanged = formattedDate;
    // this.dateValueChange.emit(selectedCode);
  }

  displayMobileTooltipReceiver() {
    this.onDisplayMobileTooltipEmitter.emit();
  }

  corpMobileTooltipReceiver(config){
    const data = config.infoIconData.content;
    this.corpTooltipHandler.emit(data);
  }
}
